import React, { useState, useEffect, useRef } from 'react';
import { MDBDataTable } from 'mdbreact';
import Swal from 'sweetalert2';
import { Button, Container, IconButton } from '@mui/material';
import { baseURL } from '../base_url';
import axios from 'axios';
import { PuffLoader } from 'react-spinners';
import DatePicker from 'react-datepicker';
import { FaDownload } from 'react-icons/fa';
import moment from 'moment';
import  './TollsReport.css';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const TollsReport = () => {

    const daysBetweenDates = () => {
      const today = new Date();
      const firstOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      const diffTime = Math.abs(today - firstOfMonth);
      return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    }
    const getOrdinalSuffix = (day) => {
      if (day > 3 && day < 21) return 'th'; // 11th, 12th, 13th, etc.
      switch (day % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    };
    const formatDateRangeWithOrdinal = (startDate, endDate) => {
      const startMoment = moment(startDate);
      const endMoment = moment(endDate);
    
      const startDay = startMoment.date();
      const startMonth = startMoment.format('MMMM');
      const startYear = startMoment.year();
      const startDayWithSuffix = startDay + getOrdinalSuffix(startDay);
    
      const endDay = endMoment.date();
      const endMonth = endMoment.format('MMMM');
      const endYear = endMoment.year();
      const endDayWithSuffix = endDay + getOrdinalSuffix(endDay);
    
      return `${startDayWithSuffix} ${startMonth} ${startYear} - ${endDayWithSuffix} ${endMonth} ${endYear}`;
    };

    const [loading, setLoading] = useState(false)
    const [showTable, setShowTable] = useState(false)
    const loggedInUser = sessionStorage.getItem("tm_token");
    const foundUser = JSON.parse(loggedInUser);
    const [selectedFromDate, setSelectedFromDate] = useState(new Date(new Date().setDate(new Date().getDate() - daysBetweenDates() + 1)));
    const [selectedToDate, setSelectedToDate] = useState(new Date());
    const [total, setTotal] = useState('');
    const [locationTeamTotal, setLocationTeamTotal] = useState('');
    const [telematicTeamTotal, setTelematicTeamTotal] = useState('');
    const [usTotal, setUSTotal] = useState('');
    const [canadaTotal, setCanadaTotal] = useState('');
    const [chargedByTelematicTeam, setChargedByTelematicTeam] = useState([])
    const [telematicTeamLocationWise, setTelematicTeamLocationWise] = useState([])
    const [locationWise, setLocationWise] = useState([])
    const [dateRange, setDateRange] = useState('')
    const [telematicsTotalCount, setTelematicsTotalCount] = useState('')
    const [locationTotalCount, setLocationTotalCount] = useState('')
    const [showTable2, setShowTable2] = useState(false)
    const [allAgreements, setAllAgreements] = useState([])

    const [apiWiseSummary, setApiWiseSummary] = useState([]);
    const [apiMakeSummary, setApiMakeSummary] = useState({});
    const [apiTotals, setApiTotals] = useState({});
    const [ridesIqLocationWise, setRidesIqLocationWise] = useState([]);

    const handleGenerateReport = () => {
      setLoading(true)
      const fromDate = new Date(selectedFromDate).toDateString()
      const toDate = new Date(selectedToDate).toDateString()
      axios.post(baseURL + "/generate_tolls_report", {
        'from': fromDate, 
        'to': toDate,
        'admin_id': foundUser['tm_id']
      }).then((res) => {
        const formattedDateRange1 = formatDateRangeWithOrdinal(res.data.from_date, res.data.to_date);
        setDateRange(formattedDateRange1)
        const myDataSet = res.data.report;
        let telematicsTotal = 0
        let locationTotal = 0
        let usSum = 0
        let canadaSum = 0
        let telematicsTotalCount = 0
        let locationTotalCount = 0
        for (var index = 0; index < res.data.report.length; index++) {
          const val = myDataSet[index];
          telematicsTotal = telematicsTotal + val.telematic_team_total_sum
          locationTotal = locationTotal + val.location_team_total_sum
          telematicsTotalCount = telematicsTotalCount + val.telematic_team_count
          locationTotalCount = locationTotalCount + val.location_team_count
          if(val.location_name == 'ORD' || val.location_name == 'ATL' || val.location_name == 'DEN' || val.location_name == 'AUR' || val.location_name == 'MCO' || val.location_name == 'AURORA')
          {
            usSum = usSum + val.location_team_total_sum + val.telematic_team_total_sum
          }
          else{
            canadaSum = canadaSum + val.location_team_total_sum + val.telematic_team_total_sum
          }
        }
        setTelematicTeamTotal(telematicsTotal)
        setLocationTeamTotal(locationTotal)
        setTotal(telematicsTotal+locationTotal)
        setUSTotal(usSum)
        setCanadaTotal(canadaSum)
        setTelematicsTotalCount(telematicsTotalCount)
        setLocationTotalCount(locationTotalCount)
        setAllAgreements(res.data.all_agreements)

        if (res.data.api_wise) {
          const apiTotalsObj = {};
          const apiMakeSummaryObj = {};

          for (const api in res.data.api_wise) {
            let total = 0;

            for (const agreementId in res.data.api_wise[api]) {
              const agreement = res.data.api_wise[api][agreementId];
              total += agreement.charge_total || 0;

              let make = agreement.make || "Unknown";

              if (api === "stellantis") {
                make = make.toUpperCase();
              }

              if (api === "ridesiq") {
                make = make.toUpperCase();
              }

              // Init API if not present
              if (!apiMakeSummaryObj[api]) {
                apiMakeSummaryObj[api] = {};
              }

              // Init Make if not present
              if (!apiMakeSummaryObj[api][make]) {
                apiMakeSummaryObj[api][make] = {
                  count: 0,
                  totalChargeAmount: 0,
                  totalChargeTotal: 0
                };
              }

              // Increment values
              apiMakeSummaryObj[api][make].count += 1;
              apiMakeSummaryObj[api][make].totalChargeAmount += agreement.charge_amount || 0;
              apiMakeSummaryObj[api][make].totalChargeTotal += agreement.charge_total || 0;
            }

            apiTotalsObj[api] = total.toFixed(2);
          }

          setApiTotals(apiTotalsObj);

          // API level totals
          const apiWise = Object.entries(apiTotalsObj).map(([api, total]) => ({
            api,
            total
          }));
          setApiWiseSummary(apiWise);
          // apiWiseSummary)

          // API → Make level details
          setApiMakeSummary(apiMakeSummaryObj);
        }
        // RidesIQ Location Wise Summary
        const ridesIqLocationWise = [];
        if (res.data.api_wise?.ridesiq) {
          const ridesiqData = res.data.api_wise.ridesiq;
          const locationMap = {};

          for (const agreementId in ridesiqData) {
            const agreement = ridesiqData[agreementId];
            const loc = agreement.location_name || "Unknown";

            if (!locationMap[loc]) {
              locationMap[loc] = { total: 0, count: 0 };
            }

            locationMap[loc].total += agreement.charge_total || 0;
            locationMap[loc].count += 1;
          }

          // Convert map to array for table rendering
          for (const loc in locationMap) {
            ridesIqLocationWise.push({
              location: loc,
              total: locationMap[loc].total,
              count: locationMap[loc].count
            });
          }
        }
        setRidesIqLocationWise(ridesIqLocationWise);

        const telematicsTeam = res.data.report
        .filter((val1) => val1.telematic_team_total_sum !== 0)
        .map((val1) => {
          return { name: val1.location_name, total: val1.telematic_team_total_sum, count: val1.telematic_team_count, tax: val1.telematic_team_tax_sum, amount:val1.telematic_team_amount_sum }
        });
        setTelematicTeamLocationWise(telematicsTeam)

        const locationTeam = res.data.report
        .filter((val2) => val2.location_team_total_sum !== 0)
        .map((val2) => {
          return { name: val2.location_name, total: val2.location_team_total_sum, count: val2.location_team_count, tax: val2.location_team_tax_sum, amount:val2.location_team_amount_sum}
        });
        setLocationWise(locationTeam)

        const telematicsTeamCharged = Object.entries(res.data.telematics_team_charged).map(([name, total]) => {
          return { name, total };
        });
        setChargedByTelematicTeam(telematicsTeamCharged)
        setShowTable(true)
      })
      .catch(err => {
        console.error(err);
      })
      .finally(() => {
        setLoading(false); // hide spinner
      });
    }

    const handleDownloadReport = async () => {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Report');
    
      // Helper function to add data with borders, custom header styles, and column widths
      const addTableWithStyles = (data, startRow, mainHeaderStyle, secondaryHeaderStyle, colWidths) => {
        if (!Array.isArray(data) || !data.every(row => Array.isArray(row))) {
          throw new TypeError('Data must be an array of arrays.');
        }
      
        data.forEach((row, rowIndex) => {
          row.forEach((cell, colIndex) => {
            const cellAddress = worksheet.getCell(startRow + rowIndex, colIndex + 1);
            cellAddress.value = cell;
      
            // Apply border style
            cellAddress.border = {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
              right: { style: 'thin' },
            };
      
            // Apply styles conditionally
            if (rowIndex === 0 && mainHeaderStyle) {
              // Apply main header style
              cellAddress.font = { ...mainHeaderStyle.font }; // Include font size her
              cellAddress.fill = mainHeaderStyle.fill;
              cellAddress.alignment = { horizontal: 'center' };
            } else if (rowIndex === 1 && secondaryHeaderStyle) {
              // Apply secondary header style
              cellAddress.font = { ...secondaryHeaderStyle.font }; // Include font size her
              cellAddress.fill = secondaryHeaderStyle.fill;
              cellAddress.alignment = { horizontal: 'center' };
            }
            if (String(row[0]).trim().toLowerCase() === "total") {
              cellAddress.font = { ...(cellAddress.font || {}), bold: true };
            }
          });
        });
      
        // Set column widths
        colWidths.forEach((width, colIndex) => {
          worksheet.getColumn(colIndex + 1).width = width;
        });
      };

      const BcfHeadderStyle = {
        fill: {
          type: 'gradient',
          pattern: 'angle',
          // fgColor: { argb: 'FFFFFF' }, // Light blue background
          degree: 135,
            stops: [
              { position: 0, color: { argb: 'FF2E5ECE' } },
              { position: 1, color: { argb: 'FF45AAF2' } }
            ]
        },
        font: {
          size: 18,
          bold: true,
          color: { argb: 'FFFFFFFF' },
        }
      }
    
      // Define styles for the headers
      const firstHeaderStyle = {
        fill: {
          // type: 'pattern',
          type: 'gradient',
          pattern: 'angle',
          fgColor: { argb: '4BAAC8' }, // Light blue background
          degree: 135,
          stops: [
            { position: 0, color: { argb: 'FF2E5ECE' } }, // #2e5ece
            { position: 1, color: { argb: 'FF45AAF2' } }  // #45aaf2
          ]
        },
        font: {
          size: 16, 
          bold: true,
          color: {  argb: 'FFFFFFFF' },
        }
      };
    
      const secondHeaderStyle = {
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFE3F2FD' }, // pink background
        },
        font: {
          size: 14, 
          bold: true,
          color: { argb: 'FF1E3A8A' }, 
        }
      };
    
      const header = [[`Tolls charges | ${dateRange}`], []];
    
      const totalTable = [
        ['Total Amount', 'Location Team', 'Telematic Team'],
        [`$${total.toLocaleString()}`, `$${locationTeamTotal.toLocaleString()}`, `$${telematicTeamTotal.toLocaleString()}`],
        []
      ];
    
      const countryTable = [
        ['Currency($)', 'Total Amount'],
        ['US', `$${usTotal.toLocaleString()}`],
        ['CANADA', `$${canadaTotal.toLocaleString()}`],
        []
      ];
    
      const chargedByTelematicTeamData = [
        ['Charged by Telematic Team'],
        ['Name', 'Total Amount'],
        ...chargedByTelematicTeam.map(person => [person.name, `$${person.total.toLocaleString()}`]),
        ['Total',`$${telematicTeamTotal.toLocaleString()}`],
        [],
      ];
    
      const telematicTeamLocationWiseData = [
        ['Telematic Team Location Wise'],
        ['Location', 'Net Amount', 'Tax', 'Total Amount', 'Count'],
        ...telematicTeamLocationWise.map(loc => [
          loc.name, 
          `$${loc.amount.toLocaleString()}`, 
          `$${loc.tax.toLocaleString()}`,
          `$${loc.total.toLocaleString()}`, 
           loc.count.toLocaleString()]),
        [
          'Total',
          '',
          '',
          `$${telematicTeamTotal.toLocaleString()}`,
          telematicTeamLocationWise.reduce((acc, loc) => acc + loc.count, 0).toLocaleString()
        ],
        [],
      ];
    
      const locationWiseData = [
        ['Applied At Location'],
        ['Location', 'Net Amount', 'Tax', 'Total Amount', 'Count'],
        ...locationWise.map(loc => [
          loc.name,
          `$${loc.amount.toLocaleString()}`,
          `$${loc.tax.toLocaleString()}`,
          `$${loc.total.toLocaleString()}`,
          loc.count.toLocaleString()
        ]),
        [
          'Total',
          '',
          '',
          `$${locationTeamTotal.toLocaleString()}`,
          locationWise.reduce((acc, loc) => acc + loc.count, 0).toLocaleString()
        ],
      ];
      const apiWiseData = [
        ['API', 'Make', 'Total Amount', 'Count'],
        ...Object.entries(apiMakeSummary).flatMap(([api, makes]) =>
          Object.entries(makes).map(([make, values]) => [
            api,
            make,
            `$${values.totalChargeTotal.toLocaleString()}`,
            values.count.toLocaleString()
          ])
        )
      ];

      // API wise
      const apiWiseDataWithHeader = [
        ['API Wise Report'], // <- this will get blue style (firstHeaderStyle)
        ['API', 'Make', 'Total Amount', 'Count'], // <- this will get pink style (secondHeaderStyle)
        ...apiWiseData.slice(1), // skip original header since we are adding styled one here
      ];


      // --- RidesIQ Location Wise ---
      const ridesIqDataWithHeader = [
      ['RidesIQ Location Wise Report'], 
      ['Location', 'Total Amount', 'Count'], 
      ...ridesIqLocationWise.map(loc => [
        loc.location,
        `$${loc.total.toLocaleString()}`,
        loc.count.toLocaleString()
      ]),
      [
        'Total',
        `$${ridesIqLocationWise.reduce((acc, loc) => acc + loc.total, 0).toLocaleString()}`,
        ridesIqLocationWise.reduce((acc, loc) => acc + loc.count, 0).toLocaleString()
      ],
    ];
    
      let startRow = 1;
    
      try {
        // Add general data
        worksheet.mergeCells('A1:E1'); // BCF Charges colspan
        addTableWithStyles(header, startRow, BcfHeadderStyle, null, [20, 20, 20, 20, 20]);
        startRow += header.length;
    
        // addTableWithStyles(totalTable, startRow, firstHeaderStyle, null, [20, 20, 20, 20, 20]);
        // startRow += totalTable.length;
    
        // addTableWithStyles(countryTable, startRow, firstHeaderStyle, null, [20, 20, 20, 20, 20]);
        // startRow += countryTable.length;
    
        worksheet.mergeCells(`A${startRow}:B${startRow}`); // Charged by Telematic Team colspan
        addTableWithStyles(chargedByTelematicTeamData, startRow, firstHeaderStyle, secondHeaderStyle, [20, 20]);
        startRow += chargedByTelematicTeamData.length;
    
        // worksheet.mergeCells(`A${startRow}:C${startRow}`);
        // addTableWithStyles(telematicTeamLocationWiseData, startRow, firstHeaderStyle, secondHeaderStyle, [20, 20, 20]);
        // startRow += telematicTeamLocationWiseData.length;
    
        // worksheet.mergeCells(`A${startRow}:E${startRow}`);
        // addTableWithStyles(locationWiseData, startRow, firstHeaderStyle, secondHeaderStyle, [20, 20, 20, 20, 20]);
        // startRow += locationWiseData.length + 1;

        // --- API Wise Table ---
        worksheet.mergeCells(`A${startRow}:D${startRow}`); // merge header across 4 columns
        addTableWithStyles(apiWiseDataWithHeader, startRow, firstHeaderStyle, secondHeaderStyle, [20, 20, 20, 20]);
        // Now merge API column cells for same API
        let currentApi = null;
        let mergeStart = null;

        apiWiseDataWithHeader.slice(2).forEach((row, index) => { // skip headers
          const rowNumber = startRow + 2 + index; 
          const cell = worksheet.getCell(`A${rowNumber}`);

          if (cell.value) {
            cell.value = String(cell.value).toUpperCase();
          }

          if (row[0] !== currentApi) {
            // close previous merge if needed
            if (mergeStart !== null && rowNumber - 1 > mergeStart) {
              worksheet.mergeCells(`A${mergeStart}:A${rowNumber - 1}`);
              worksheet.getCell(`A${mergeStart}`).alignment = { vertical: 'middle', horizontal: 'center' };
            }
            // start new group
            currentApi = row[0];
            mergeStart = rowNumber;
          }
        });

        // close last group
        if (mergeStart !== null) {
          const lastRow = startRow + apiWiseDataWithHeader.length - 1;
          if (lastRow > mergeStart) {
            worksheet.mergeCells(`A${mergeStart}:A${lastRow}`);
            worksheet.getCell(`A${mergeStart}`).alignment = { vertical: 'middle', horizontal: 'center' };
          }
        }
        // Center align all values in API column (column A)
        const firstDataRow = startRow + 2; // skip merged header + subheader
        const lastDataRow = startRow + apiWiseDataWithHeader.length - 1;

        for (let r = firstDataRow; r <= lastDataRow; r++) {
          worksheet.getCell(`A${r}`).alignment = { vertical: 'middle', horizontal: 'center' };
        }

        startRow += apiWiseDataWithHeader.length;

        // Add totals row for API Wise
        const apiTotalAmount = Object.values(apiMakeSummary).reduce(
          (sum, makes) => sum + Object.values(makes).reduce((s, v) => s + v.totalChargeTotal, 0),
          0
        );
        const apiTotalCount = Object.values(apiMakeSummary).reduce(
          (sum, makes) => sum + Object.values(makes).reduce((s, v) => s + v.count, 0),
          0
        );
        const totalRow = worksheet.addRow([
          'Total',
          '',
          `$${apiTotalAmount.toLocaleString()}`,
          apiTotalCount.toLocaleString()
        ]);
        totalRow.eachCell((cell) => {
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
          };
          cell.font = { bold: true }; // make it stand out
        });
        startRow += 2; // move pointer down
        // --- RidesIQ Location Wise ---
        worksheet.mergeCells(`A${startRow}:C${startRow}`);
        addTableWithStyles(ridesIqDataWithHeader, startRow, firstHeaderStyle, secondHeaderStyle, [20, 20, 20]);

        startRow += ridesIqDataWithHeader.length + 1;

      } catch (error) {
        console.error('Error adding table with styles:', error);
      }

      // Add new worksheet for agreements
      const agreementsWorksheet = workbook.addWorksheet('Agreements');

      // Define column headers for agreements
      const agreementHeaders = [
        ['Agreement Number', 'Return Date', 'Location', 'Charged Type', 'Amount', 'Admin Fees with Tax' , 'Total'],
      ];

      // Transform the agreements object into a 2D array
      const agreementsData = Object.values(allAgreements).map(agreement => [
        agreement.agreement_number,
        agreement.return_date,
        agreement.location_name,
        agreement.charge_option === 'penalty_imposed' ? 'Penalty Imposed' :
        agreement.charge_option === 'charge_at_counter' ? 'Charge At Counter' :
        agreement.charge_option, // Default case, if other charge_option values exist
        `$${agreement.charge_amount.toLocaleString()}`,
        `$${agreement.admin_fees_with_tax.toLocaleString()}`,
        `$${agreement.charge_total.toLocaleString()}`,
      ]);

      // Merge header and data for the table
      const completeAgreementsData = [...agreementHeaders, ...agreementsData];

      // Add the table to the agreements worksheet
      agreementsWorksheet.addRows(completeAgreementsData);

      // Set column widths for the agreements worksheet
      agreementsWorksheet.columns = [
        { width: 20 }, // Agreement Number
        { width: 15 }, // Return Date
        { width: 10 }, // Location Name
        { width: 20 }, // Charge Option
        { width: 10 }, // Charge Amount
        { width: 26 }, // Admin Fees
        { width: 15 }, // Charge Total
      ];

      // Apply basic styles to the agreements table
      completeAgreementsData.forEach((row, rowIndex) => {
        row.forEach((_, colIndex) => {
          const cell = agreementsWorksheet.getCell(rowIndex + 1, colIndex + 1);
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
          };

          if (rowIndex === 0) {
            // Apply header style
            cell.font = { bold: true, color: { argb: 'FFFFFF' } };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF2E5ECE' } };
            cell.alignment = { horizontal: 'center' };
          }
        });
      });

    
      // Create buffer and save file
      try {
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), 'Tolls Report.xlsx');
      } catch (error) {
        console.error('Error saving file:', error);
      }
    };
    
    return(
      <div className='body_class'>
      {loading && (
        <div className="loader-overlay">
          <div className="loader">
            <PuffLoader color="#00308F" loading={true} size={200} />
          </div>
        </div>
      )}
      <div className='container-fluid'>
        <h4>Tolls Report</h4>
        <div className="mt-3">
          {foundUser['tm_accessRole']['Fleet']['Edit'] === true && (
            <>
              <div className='row p-4 align-items-center'>
                <div className="col-auto">
                  <label htmlFor="datepicker" className="form-label">Start Date:</label>
                </div>
                <div className='col-2'>
                  <DatePicker
                    id="start-date"
                    selected={selectedFromDate}
                    onChange={(date) => setSelectedFromDate(date)}
                    className="form-control"
                  />
                </div>
                <div className="col-auto">
                  <label htmlFor="datepicker" className="form-label">To Date:</label>
                </div>
                <div className='col-2'>
                  <DatePicker
                    id="end-date"
                    selected={selectedToDate}
                    onChange={(date) => setSelectedToDate(date)}
                    className="form-control"
                  />
                </div>
                <div className="col-auto">
                  <Button size='large' variant="contained" component="span" className="btn btn-primary" onClick={handleGenerateReport}>Generate Report</Button>
                </div>
              </div>
            </>
          )}
        </div>
        {
          showTable && 
          <div>
            <div className="col-auto">
              <Button size='large' variant="contained" component="span" className="btn btn-primary" onClick={handleDownloadReport}>Download Report</Button>
            </div>
          </div>
        }
        {showTable &&
          <div className="table-container">
            <hr/>
            <h4 style={{backgroundColor:""}}>Tolls charges | {dateRange}</h4>
            <hr/>
            {/* <div className="currency-table1">
              <table className="table-inline">
                <thead>
                  <tr>
                    <th>Total Amount</th>
                    <th>Location Team</th>
                    <th>Telematic Team</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>${total.toLocaleString()}</td>
                    <td>${locationTeamTotal.toLocaleString()}</td>
                    <td>${telematicTeamTotal.toLocaleString()}</td>
                  </tr>
                </tbody>
              </table>
              <table className="table-inline">
                <thead>
                  <tr>
                    <th>Currency($)</th>
                    <th>Total Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>US</td>
                    <td>${usTotal.toLocaleString()}</td>
                  </tr>
                  <tr>
                    <td>CANADA</td>
                    <td>${canadaTotal.toLocaleString()}</td>
                  </tr>
                </tbody>
              </table>
            </div> */}
            <div className="currency-table2-container">
              <div className="currency-table2">
                <h5>Charged by Telematic Team</h5>
                <table className="charged-amounts-table">
                    <thead>
                      <tr>
                        {chargedByTelematicTeam.map((person, index) => (
                          <th key={index}>{person.name}</th>
                        ))}
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        {chargedByTelematicTeam.map((person, index) => (
                          <td key={index}>${person.total.toLocaleString()}</td>
                        ))}
                        <td>${telematicTeamTotal.toLocaleString()}</td>
                      </tr>
                      
                    </tbody>
                </table>
                <br></br>
                <table className="charged-amounts-table">
                    <thead>
                        <tr>
                            <th>Location</th>
                            <th>Toll Amount</th>
                            <th>Admin Fees</th>
                            <th>Total Amount</th>
                            <th>Count</th>
                        </tr>
                    </thead>
                    <tbody>
                        {telematicTeamLocationWise.map((loc, index) => (
                            <tr key={index}>
                                <td>{loc.name}</td>
                                <td>${loc.amount.toLocaleString()}</td>
                                <td>${loc.tax.toLocaleString()}</td>
                                <td>${loc.total.toLocaleString()}</td>
                                <td>{loc.count.toLocaleString()}</td>
                            </tr>
                        ))}
                        <tr style={{fontWeight:"bold"}}>
                          <td colSpan={3}>Total</td>
                          <td>${telematicTeamTotal.toLocaleString()}</td>
                          <td>{telematicsTotalCount.toLocaleString()}</td>
                        </tr>
                    </tbody>
                </table>
              </div>
              {/* <div className="currency-table2"> 
                <h5>Applied At Location</h5>
                <table className="charged-amounts-table">
                    <thead>
                        <tr>
                            <th>Location</th>
                            <th>Net Amount</th>
                            <th>Tax</th>
                            <th>Total Amount</th>
                            <th>Count</th>
                        </tr>
                    </thead>
                    <tbody>
                        {locationWise.map((loc, index) => (
                            <tr key={index}>
                                <td>{loc.name}</td>
                                <td>${loc.amount.toLocaleString()}</td>
                                <td>${loc.tax.toLocaleString()}</td>
                                <td>${loc.total.toLocaleString()}</td>
                                <td>{loc.count.toLocaleString()}</td>
                            </tr>
                        ))}
                        <tr style={{fontWeight:"bold"}}>
                          <td colSpan={3}>Total</td>
                          <td>${locationTeamTotal.toLocaleString()}</td>
                          <td>{locationTotalCount.toLocaleString()}</td>
                        </tr>
                    </tbody>
                </table>
              </div>*/}
            </div>
          </div>
        }
        {showTable2 &&
          <div className="table-container">
            <hr/>
              <h4 style={{backgroundColor:""}}>Tolls charges | {dateRange}</h4>
            <hr/>
          </div>
        }
        {showTable && (
          <div className="row mt-4 mb-4">
            {/* API Wise Report */}
            <div className="col-md-6">
              <div className="currency-table2" style={{ textAlign: "left" }}>
                <h5 className="mb-3">API Wise Report</h5>
                <table>
                  <thead>
                    <tr>
                      <th>API</th>
                      <th>Make</th>
                      <th>Total Amount</th>
                      <th>Count</th>
                    </tr>
                  </thead>
                  <tbody>
                    {apiWiseSummary.map(({ api }) => {
                      const makes = apiMakeSummary[api] || {};
                      const makeKeys = Object.keys(makes);

                      return makeKeys.length > 0
                        ? makeKeys.map((make, i) => (
                            <tr key={`${api}-${make}`}>
                              {i === 0 && (
                                <td rowSpan={makeKeys.length}>{api.toUpperCase()}</td>
                              )}
                              <td>{make}</td>
                              <td>${(makes[make]?.totalChargeTotal || 0).toFixed(2)}</td>
                              <td>{makes[make]?.count || 0}</td>
                            </tr>
                          ))
                        : (
                            <tr key={api}>
                              <td className="fw-bold">{api}</td>
                              <td colSpan="3">No Makes Found</td>
                            </tr>
                          );
                    })}
                    <tr className="fw-bold table-secondary">
                      <td colSpan="2" className="text-end">Total</td>
                      <td>
                        ${apiWiseSummary.reduce((sum, { api }) => {
                          const makes = apiMakeSummary[api] || {};
                          return sum + Object.values(makes).reduce((a, m) => a + (m.totalChargeTotal || 0), 0);
                        }, 0).toFixed(2)}
                      </td>
                      <td>
                        {apiWiseSummary.reduce((sum, { api }) => {
                          const makes = apiMakeSummary[api] || {};
                          return sum + Object.values(makes).reduce((a, m) => a + (m.count || 0), 0);
                        }, 0)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            {/* RidesIQ Location wise */}
            <div className="col-md-6">
              <div className="currency-table2" style={{ textAlign: "left" }}>
                <h5 className="mb-3">RidesIQ Location Wise Report</h5>
                <table>
                  <thead>
                    <tr>
                      <th>Location</th>
                      <th>Total Amount</th>
                      <th>Count</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ridesIqLocationWise.map((row, index) => (
                      <tr key={index}>
                        <td>{row.location}</td>
                        <td>${row.total.toFixed(2)}</td>
                        <td>{row.count}</td>
                      </tr>
                    ))}
                    <tr className="fw-bold">
                      <td>Total</td>
                      <td>
                        ${ridesIqLocationWise.reduce((sum, row) => sum + (row.total || 0), 0).toFixed(2)}
                      </td>
                      <td>
                        {ridesIqLocationWise.reduce((sum, row) => sum + (row.count || 0), 0)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
    )
}

export default TollsReport;